/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        modal: {
            borderRadius: {
                value: "12px",
                type: "dimension",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            color: {
                value: "#282e37",
                type: "color",
            },
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "10px",
                            blur: "24px",
                            spread: "0px",
                            color: "#161B2B29",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "2px",
                            spread: "0px",
                            color: "#161B2B1A",
                        },
                    ],
                    stringValue: "0px 10px 24px 0px #161B2B29, 0px 0px 2px 0px #161B2B1A",
                },
                type: "shadow",
            },
            maxWidth: {
                value: "480px",
                type: "dimension",
            },
            header: {
                paddingLeft: {
                    value: "24px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "24px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "24px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "24px",
                    type: "dimension",
                },
                gap: {
                    value: "24px",
                    type: "dimension",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                fontSize: {
                    value: "1.375rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.75rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0px",
                    type: "dimension",
                },
                icon: {
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                },
                description: {
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    marginTop: {
                        value: "4px",
                        type: "dimension",
                    },
                },
            },
            content: {
                paddingLeft: {
                    value: "24px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "24px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "24px",
                    type: "dimension",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
                lineHeight: {
                    value: "1.5rem",
                    type: "dimension",
                },
            },
            footer: {
                gap: {
                    value: "16px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "24px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "24px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "24px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "24px",
                    type: "dimension",
                },
                borderTopWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderTopStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
                borderTopColor: {
                    value: "#dadada",
                    type: "color",
                },
                checkbox: {
                    gap: {
                        value: "10px",
                        type: "dimension",
                    },
                },
            },
            backdrop: {
                backgroundColor: {
                    value: "#282e3780",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
